'use strict';
import angular from 'angular';
import ngMessages from 'angular-messages';
import GeneralInfoController from './general-info.controller';
import UserService from '../../../auth/user.service';
import GeneralInfoService from './general-info.service';
import ngMaterial from 'angular-material';
export default angular.module('directives.generalInfoForm', [ngMessages, ngMaterial])
    .service('UserService', UserService)
    .service('GeneralInfoService', GeneralInfoService)
    .component('generalInfoForm', {
    template: require('./general.html'),
    controller: GeneralInfoController,
    controllerAs: 'gi',
    bindings: {
        user: '<',
        mode: '<',
        audience: '<',
        onUpdate: '&'
    }
})
    .name;
//# sourceMappingURL=index.js.map